export class BrowserTab {
	public static reload(): void {
		window.location.reload();
	}
}
